import { Breadcrumbs, BreadcrumbsProps } from "@mui/material";
import * as React from "react";

import { NavigateNextIcon } from "@/shared/foundation/icons/mui";

import styles from "./PageBreadcrumbs.module.css";

export interface PageBreadcrumbsProps extends Omit<
  BreadcrumbsProps,
  "separator"
> {
  children: React.ReactNode;
}

/**
 * Shared breadcrumbs component for use in PageLayout headers.
 *
 * Expects each child to be wrapped in an `<a>` or `<span>`.
 */
export function PageBreadcrumbs(props: PageBreadcrumbsProps) {
  const { children } = props;

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      className={styles.breadcrumbsContainer}
      separator={<NavigateNextIcon fontSize="small" />}
    >
      {children}
    </Breadcrumbs>
  );
}
